import React from 'react';
import cardShape from 'app/shapes/cardShape';

export default function ContentCardDescription({ card }) {
  const description = card.getIn(['description', 'text']);
  return description ? <p className="cp-content-card-description">{description}</p> : null;
}

ContentCardDescription.propTypes = {
  card: cardShape.isRequired
};
